import axios from 'axios';
import { LINB_API } from 'common/constants/api-urls';
import { IterationSummaryResponse } from './iteration-summary.model';

export const fetchIterationSummary = async ({
  teamId,
  iterationProviderId
}): Promise<IterationSummaryResponse> => {
  const payload = {
    scope: {
      team_id: teamId,
      iteration_id: iterationProviderId
    },
    insight_name: 'iteration_summary'
  };

  return await axios.post(LINB_API.VISION_AI.ITERATION_SUMMARY, payload);
};
